
import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Header */}
      <section className="pt-32 pb-20 bg-green-100 relative">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <span className="text-green-600 font-display uppercase tracking-wider text-sm mb-2 block animate-fade-up">
              About Us
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-6 text-gray-900 animate-fade-up">
              Our Story
            </h1>
            <p className="text-xl text-gray-700 animate-fade-up">
              Learn about PK Landscape Associates and our commitment to creating 
              exceptional outdoor spaces throughout Fairfield County.
            </p>
          </div>
        </div>
      </section>
      
      {/* Main content section - will be expanded later */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-serif font-bold mb-6 text-gray-900">
              About PK Landscape Associates
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              PK Landscape Associates was founded with a vision of creating beautiful, 
              functional landscapes that enhance the natural beauty of Fairfield County properties.
              With years of experience and a passion for exceptional craftsmanship, we have 
              established ourselves as a trusted partner for homeowners and businesses alike.
            </p>
            <p className="text-lg text-gray-700 mb-6">
              Our team of skilled professionals brings expertise in landscape design, 
              installation, and maintenance, ensuring that every project is completed 
              with the highest standards of quality and attention to detail.
            </p>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default About;
